export default `
  @font-face {
    font-family: 'Benton-Sans-Regular';
    font-weight: 400;
    font-style: normal;
    font-display: block;
    src: url('${
      process.env.LOCAL_EXPORT ? process.env.BASE_PATH : ''
    }/fonts/Benton_Sans-Regular.woff2') format('woff2')
  }

  @font-face {
    font-family: 'Benton-Sans-Italic';
    font-weight: 400;
    font-style: normal;
    font-display: block;
    font-style: italic;
    src: url('${
      process.env.LOCAL_EXPORT ? process.env.BASE_PATH : ''
    }/fonts/Benton_Sans-Italic.woff2') format('woff2')
  }

  @font-face {
    font-family: 'Benton-Sans-Black';
    font-weight: 900;
    font-style: normal;
    font-display: block;
    src: url('${
      process.env.LOCAL_EXPORT ? process.env.BASE_PATH : ''
    }/fonts/Benton_Sans-Black.woff2') format('woff2')
  }

  @font-face {
    font-family: 'Benton-Sans-Black_Italic';
    font-weight: 900;
    font-style: normal;
    font-display: block;
    font-style: italic;
    src: url('${
      process.env.LOCAL_EXPORT ? process.env.BASE_PATH : ''
    }/fonts/Benton_Sans-Black_Italic.woff2') format('woff2')
  }

  @font-face {
    font-family: 'Benton-Sans-Bold';
    font-weight: 800;
    font-style: normal;
    font-display: block;
    src: url('${
      process.env.LOCAL_EXPORT ? process.env.BASE_PATH : ''
    }/fonts/Benton_Sans-Bold.woff2') format('woff2')
  }

  @font-face {
    font-family: 'Benton-Sans-Bold_Italic';
    font-weight: 800;
    font-style: normal;
    font-display: block;
    font-style: italic;
    src: url('${
      process.env.LOCAL_EXPORT ? process.env.BASE_PATH : ''
    }/fonts/Benton_Sans-Bold_Italic.woff2') format('woff2')
  }

  @font-face {
    font-family: 'Benton-Sans-Light';
    font-weight: 300;
    font-style: normal;
    font-display: block;
    src: url('${
      process.env.LOCAL_EXPORT ? process.env.BASE_PATH : ''
    }/fonts/Benton_Sans-Light.woff2') format('woff2')
  }

  @font-face {
    font-family: 'Benton-Sans-Light_Italic';
    font-weight: 300;
    font-style: normal;
    font-display: block;
    font-style: italic;
    src: url('${
      process.env.LOCAL_EXPORT ? process.env.BASE_PATH : ''
    }/fonts/Benton_Sans-Light_Italic.woff2') format('woff2')
  }

  @font-face {
    font-family: 'Benton-Sans-Condensed_Medium';
    font-weight: 400;
    font-style: normal;
    font-display: block;
    src: url('${
      process.env.LOCAL_EXPORT ? process.env.BASE_PATH : ''
    }/fonts/Benton_Sans-Condensed_Medium.woff2') format('woff2')
  }

  @font-face {
    font-family: 'BwGradualDEMO-bold';
    font-weight: 800;
    font-style: normal;
    font-display: block;
    src: url('${
      process.env.LOCAL_EXPORT ? process.env.BASE_PATH : ''
    }/fonts/BwGradualDEMO-bold.woff2') format('woff2')
  }

  @font-face {
    font-family: 'BwGradual-Medium';
    font-weight: 400;
    font-display: block;
    src: url('${
      process.env.LOCAL_EXPORT ? process.env.BASE_PATH : ''
    }/fonts/BwGradual-Medium.woff2') format('woff2')
  }
`;
